<!--
 * @Author: leo.liu
 * @Date: 2021-3-13 11:04:24
 * @Last Modified by:   leo.liu
 * @Last Modified time: 2021-3-13 11:04:24
 !-->
<template>
  <div class="widget-card" :style="styleColor">
    <div style="width: 100%">
      <div class="card-title" :style="{
        color: transStyle.titleColor || '#677392',
        fontSize: `${transStyle.titleSize || '12'}px`,
      }">{{ styleColor.text }}</div>
      <div class="card-num" :style="{
        color: transStyle.normColor || '#2D3446',
        fontSize: `${transStyle.normSize || '24'}px`,
      }">{{ $fixedMath(cardValue) === false?cardValue:$getThousandths(cardValue)  }}<span v-if="symbol">({{symbol}})</span></div>
      <a-row class="card-calc" :style="{
        color: transStyle.compareColor || '#677392',
        fontSize: `${transStyle.compareSize || '12'}px`,
      }" v-if="compare">
        <a-col :span="12">
          <span>上期
            <a-tooltip overlayClassName="question-tip" placement="topLeft" :title="tooltipTitle" >
              <a-icon type="question-circle" />
            </a-tooltip>
          :</span>
          <span class="number">{{$fixedMath(compareResult) === false?compareResult:$getThousandths(compareResult)}}<span v-if="symbol">({{symbol}})</span></span> 
        </a-col>
        <a-col :span="12">
          <span>{{compareTypeMap[compare.compareType]}}:</span>
          <span class="number"  :class="{
            green: percent > 0,
            red: percent < 0
          }">{{percent>0?'+':''}}{{percent?`${percent}%`:'-'}}</span>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "widgetCard",
  components: {},
  props: {
    value: Object,
    ispreview: Boolean
  },
  data() {
    return {
      cardValue: '暂无数据',
      compareResult: 0,
      symbol: '',
      options: {},
      optionsData: {},
      optionsSetup: {},
      compareTypeMap: {
        MoM: '环比',
        YoY: '同比',
        CUSTOMIZE: '自定义',
      },
      tooltipTitle: ''
    };
  },
  inject: ["getDashboardDynamicData", "getFilterCondition"],
  computed: {
    dashbordData() {
      return this.getDashboardDynamicData()?.contextData || {}
    },
    transStyle() {
      return this.$objToOne(this.options);
    },
    styleColor() {
      return {
        position: this.ispreview ? "absolute" : "static",
        color: this.transStyle.color,
        "font-weight": this.transStyle.fontWeight,
        text: this.transStyle.text,
        "font-size": this.transStyle.fontSize + "px",
        "letter-spacing": this.transStyle.letterSpacing + "em",
        background: this.optionsSetup.background,
        "text-align": this.transStyle.textAlign,
        width: this.transStyle.width + "px",
        height: this.transStyle.height + "px",
        left: this.transStyle.left + "px",
        top: this.transStyle.top + "px",
        right: this.transStyle.right + "px"
      };
    },
    percent() {
      let currernt = this.cardValue
      let last = this.compareResult
      if(last == 0 || currernt == 0) {
        return 0
      } else {
        return ((currernt - last)/last * 100).toFixed(2) 
      }
    },
    compare() {
      let contextData = this.optionsData.dynamicData?.contextData
      return contextData?.calc?.compare?contextData.calc:false
    }
  },
  watch: {
    value: {
      handler(val) {
        this.options = val;
        this.optionsData = val.data;
        this.optionsSetup = val.setup;
        this.setOptionsData();
      },
      deep: true
    }
  },
  mounted() {
    this.options = this.value;
    this.optionsData = this.value.data;
    this.optionsSetup = this.value.setup;
    this.setOptionsData();
  },
  methods: {
    previewInit(data) {
      let field = data&&data.fields?data.fields[0]:null
      let fieldUnit = field?field.fieldUnit:null
      this.symbol = fieldUnit?fieldUnit.symbol:''
      this.cardValue = data?data.result:''
      this.compareResult = data?data.compareResult:''
      this.tooltipTitle = data.dateRang?.diffFrom?`${data.dateRang.diffFrom}~${data.dateRang.diffTo}`:''
    },
    // 数据解析
    setOptionsData() {
      const optionsData = this.optionsData; // 数据类型 静态 or 动态
      if (optionsData.dataType == "dynamicData") {
        this.dynamicDataFn(optionsData.dynamicData, optionsData.refreshTime);
      } else {};
    },
    dynamicDataFn(val, refreshTime) {
      if (!val  || !val.chartProperties || val.chartProperties.isVerified === false) return;
      this.getEchartData(val);
    },
    getEchartData(val) {
      const data = this.queryEchartsData(val.contextData,val.params, val.chartProperties);
      data.then(res => {
        let field = res&&res.fields?res.fields[0]:null
        let fieldUnit = field?field.fieldUnit:null
        this.symbol = fieldUnit?fieldUnit.symbol:''
        this.cardValue = res.result;
        this.compareResult = res.compareResult;
        // this.$forceUpdate();
      });
    }
  }
};
</script>

<style scoped lang="less">
.widget-card {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 1px solid #CBD5EE;
  border-radius: 12px;
  padding-left: 20px;
  text-align: left!important;
  display: flex;
  align-items: center;
  .card-title {
    color: #677392;
    font-size: 12px;
    line-height: 20px;
    height: 20px;
  }
  .card-num {
    color: #2D3446;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    margin-top: 4px;
    height: 32px;
  }
  .card-calc {
    color: #677392;
    font-size: 12px;
    line-height: 20px;
    height: 20px;
    margin-top: 5px;
    .number {
      // color: #2D3446;
      margin-left: 5px;
      &.green {
        color: #22AC35;
      }
      &.red {
        color: #E84E54;
      }
    }
  }
}
</style>
